<template>
  <div class="project" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="案例详情" :showBack="true"></my-header>
    <div class="case-info-detail">
      <div class="project-info">
        <div>{{caseProject.name}}</div>
        <div>{{caseProject.customerName}}</div>
      </div>
      <div class="project-house-type">
       {{caseProject.houseLayout}}&nbsp;&nbsp;&nbsp;{{caseProject.area}}㎡
      </div>
    </div>
    <div @click="toOnestopCompany(companyInfo.id)" class="supervisor-info general-box-shadow">
      <img class="supervisor-avatar" :src="imgUrl + companyInfo.logo">
      <div class="supervisor-less-info">
        <div><span class="supervisor-name">{{companyInfo.name}}</span></div>
        <div class="supervisor-auth">
          <div class="platform-auth"><img src="../../assets/appointment/icon-platform-auth.png"/> <div>平台认证</div></div>
          <div class="supervisor-deposit"><img src="../../assets/appointment/icon-deposit-auth.png"/><div>9 万</div></div>
        </div>
      </div>
      <div class="evaluate-score">
        <div class="score">{{ 5.0 }}</div>
        评分
      </div>
    </div>
    <div class="work-progress">
      <div style="display: flex">
        <div class="wp-title" @click="changeTabSelect('1')" :class="{'selected': tabItemSelect == '1'}">工长施工</div>
        <div class="wp-title" @click="changeTabSelect('2')" :class="{'selected': tabItemSelect == '2'}">施工图片</div>
      </div>
      <div class="wp-body general-box-shadow" v-if="tabItemSelect == '1'">
        <div class="wp-row" v-for="stage in projectStage" v-if="stage.type != '0'">
          <div class="wp-label" :class="{'active': stage.status === '3'}"></div>
          <div class="wp-content" :class="{'complete': stage.status === '3'}">{{stage.stageName}}
            <div v-if="stage.status === '3'" class="wp-date">{{stage.completeTime | simpleDayFilter}}</div>
          </div>
        </div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '2'">
        <div class="no-image" v-if="projectImageList.length ==0 && completeImgList.length == 0">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">暂无施工图片~</div>
        </div>
        <div v-for="projectImg in projectImageList" style="margin-left: 0.3rem">
          <div class="img-title" style="margin-top: 0.2rem;font-size: 0.36rem;color: #191818;">
            <div>{{projectImg.type | projectImageTypeConvert}}</div>
          </div>
          <div class="foreman-img-list">
            <div v-if="projectImg.attachmentList.length > 0 && projectImg.images" v-for="(recoredImg,index) in projectImg.attachmentList">
              <img class="foreman-img" :src="imgUrl + recoredImg" @click = "previewImg(recoredImg,projectImg.attachmentList)">
            </div>
            <div v-if="!projectImg.images" class="no-image">
              <img src="../../assets/icon-no-img.png">
              <div class="tip">暂无相关施工图~</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .clear-header{
    margin-top: -1rem;
  }
  .project{
    background-color: white;
    font-size: 0.36rem;
    .general-box-shadow{
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
    }
    .no-image{
      text-align: center;
      img{
        width: 1.57rem;
        height: 1.57rem;
      }
      .tip{
        margin-top: 0.4rem;
        font-size: 0.28rem;
        color: #7f7d7c;
      }
    }
    .case-info-detail{
      height: 1.64rem;
      background-image: url('../../assets/icon-default-top-bg.png');
      color: white;
      .project-info{
        display: flex;
        justify-content: space-between;
        padding: 0.3rem 0.3rem 0.2rem 0.3rem;
        font-weight: bold;
      }
      .project-house-type{
        width: 2.95rem;
        height: 0.4rem;
        line-height: 0.45rem;
        border-radius: 0.4rem;
        margin-left: 0.3rem;
        text-align: center;
        background: white;
        font-size: 0.24rem;
        color: #feac00;
      }
    }
    .supervisor-info{
      position: relative;
      display: flex;
      width: 6.9rem;
      height: 1.9rem;
      margin: 0.3rem auto 0;
      .supervisor-avatar{
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 0.06rem;
        margin: 0.3rem 0.2rem;
      }
      .supervisor-less-info{
        margin-top: 0.4rem;
        font-size: 0.28rem;
        color: #7f7d7c;
        .supervisor-name{
          margin-left: 0.2rem;
          font-weight: bold;
          font-size: 0.36rem;
          color: #191818;
        }
        .supervisor-auth{
          display: flex;
          width: 2.95rem;
          height: 0.4rem;
          line-height: 0.45rem;
          border-radius: 0.4rem;
          margin-top: 0.19rem;
          background: #e0dedc;;
          font-size: 0.24rem;
          color: #191818;
          img{
            width: 0.27rem;
            height: 0.28rem;
            margin-top: 0.06rem;
            margin-right: 0.1rem;
          }
          .platform-auth{
            display: flex;
            padding-left: 0.23rem;
          }
          .supervisor-deposit{
            display: flex;
            padding-left: 0.29rem;
          }
        }
      }
      .evaluate-score{
        position: absolute;
        right: 0.21rem;
        background: url("../../assets/icon-evaluate-bg.png") no-repeat;
        width: 0.58rem;
        height: 0.8rem;
        line-height: 0.25rem;
        background-size: 100%;
        font-size: 0.18rem;
        color: white;
        text-align: center;
        .score{
          margin-top: 0.05rem;
          font-size: 0.24rem;
          font-weight: bold;
        }
      }
    }
    .work-progress{
      padding-left: 0.3rem;
      padding-bottom: 0.5rem;
      .wp-title{
        height: 1.05rem;
        line-height: 1.1rem;
        margin-right: 0.3rem;
        color: #191818;
        font-size: 0.32rem;
      }
      .selected{
        font-weight: bold;
      }
      .wp-body{
        width: 6.9rem;
        padding-top: 0.33rem;
        padding-bottom: 0.6rem;
        box-shadow: 0rem 0.02rem 0.07rem 0rem
        rgba(0, 0, 0, 0.1);
        .node-img-list{
          display: flex;
          flex-wrap: wrap;
          width: 6rem;
          img{
            display: block;
            width: 1.75rem;
            height: 1.75rem;
            margin-top: 0.2rem;
            margin-right: 0.2rem;
          }
        }
        .foreman-img-list{
          width: 6.3rem;
          .foreman-img{
            display: block;
            max-width: 100%;
            margin-top: 0.2rem;
          }
        }
      }
      .none-complete-img{
        font-size: 0.28rem;
        color: #d5dee2;
        padding-top: 1.73rem;
        text-align: center;
        img{
          width: 0.72rem;
          height: 0.6rem;
        }
      }
      .wp-row{
        padding-left: 0.2rem;
        margin-top: 0.6rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        .wp-label{
          position: relative;
          width: 0.36rem;
          margin-top: 0.05rem;
          background: url("../../assets/icon/icon-stage-uncomplete.png") no-repeat;
          background-size: 100%;
          flex-grow: 0;
          flex-shrink: 0;
          &.active{
            width: 0.36rem;
            margin-top: 0.05rem;
            background: url("../../assets/icon/icon-stage-complete.png") no-repeat;
            background-size: 100%;
          }
        }
        &:first-child{
         margin-top:0px;
        }
        .wp-content{
          margin-left: 0.2rem;
          color: #7f7d7c;
          font-size: 0.32rem;
          font-weight: bold;
          flex-grow: 1;
          flex-shrink: 0;
          &.complete{
            color: #191818;
          }
          .wp-date{
            font-weight: normal;
            font-size: 0.24rem;
            color: #cecbca;
          }
          .stage-title{
            display: flex;
            justify-content: space-between;
            img{
              width: 0.34rem;
              height: 0.2rem;
              margin-right: 0.3rem;
            }
          }
          .category-list{
            width: 6.0rem;
            .category-name{
              display: inline-block;
              margin-top: 0.3rem;
              margin-bottom: 0.2rem;
              padding: 0.1rem 0.3rem;
              background-color: #e0dedc;
              border-radius: 20px;
              font-size: 0.24rem;
              color: #191818
            }
            .node-list{
              margin-bottom: 0.3rem;
              color: #7f7d7c;
              font-size: 0.28rem;
              font-weight: lighter;
              .node-content{
                width: 5.26rem;
                line-height: 0.4rem;
                text-align: justify;
                margin-right: 0.4rem;
              }
            }
          }
        }
      }
    }
  }
</style>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import ProjectService from '../../service/customer/ProjectService'
  import SupervisorService from '../../service/SupervisorService'
  import EvaluateService from '../../service/customer/EvaluateService'
  import shareService from '../../service/share/ShareService'
  import companyService from '../../service/company/CompanyService'
  import evaluateService from '../../service/customer/EvaluateService'
  import onestopProjectService from '../../service/onestop/OnestopProjectService';

  export default {
    name: 'Project',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        caseProject:{},
        projectStage:[],
        stage:{},
        imgUrl:imgUrl,
        shareIcon:shareIcon,
        customerEvaluateList:[],
        isWechatBrowser:this.$verfyBrowserType(),
        projectName:'',
        tabItemSelect: '1',
        completeImgList:[],
        projectImageList:[],
        companyInfo:{},
        companyEvaluate:{},
        caseProjectId:'',
        stageMap:{},
      }
    },
    created(){
      this.projectName = this.$route.query.projectName;
      this.caseProjectId = this.$route.query.id;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getCaseDetail(this.caseProjectId);
      this.initWechatShare();
    },
    methods: {
      changeTabSelect(select){
        this.tabItemSelect = select;
      },
      toOnestopCompany(companyId){
        this.$router.push({name:'OnestopCompany',query:{companyId}});
      },
      async getCaseDetail(id){//案例详情
        var result = await ProjectService.getOnestopProjectDetail(id);
        if(result.code == 0){
          this.caseProject = result.data;

          this.getProjectImageList(this.caseProjectId);
          this.getProjectStage(this.caseProject.id, '');
          this.getCompanyInfo(this.caseProject.companyId);
          this.getCompanyEvaluate(this.caseProject.companyId);

          if(this.caseProject.completeImages){
            let completeImageArray = this.caseProject.completeImages.split(',');
            let completeImage ={};
            for(let image of completeImageArray){
              completeImage = {imagePath:imgUrl+image};
              this.completeImgList.push(completeImage);
            }
          }
        }else {
          Toast('获取案例项目详情信息失败');
        }
      },

      async getCompanyInfo(id){
        let {code,data:{company}} = await companyService.getCompanyInfo(id);
        if(code == 0){
          this.companyInfo = {...company};
          console.log('this.getCompanyInfo=======', this.companyInfo)
        }else {
          Toast('获取整包公司信息失败');
        }
      },

      async getCompanyEvaluate(companyId){
        var result = await evaluateService.getCompanyEvaluate(companyId);
        if(result.code == 0){
          this.companyEvaluate = result.data;
        }else {
          Toast('获取整包公司评价信息失败');
        }
      },

      async getForemanInfo(id){
        var result=await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
          this.foreman=result.data;
        }else {
          Toast('获取工长详细信息失败');
        }
      },
      async getSupervisorInfo(id){
        var result=await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
          this.supervisor=result.data;
        }else {
          Toast('获取监理详细信息失败');
        }
      },
      async getProjectStage(id,supervisorId){
        var result = await ProjectService.getOnestopProjectStage(id,supervisorId);
        if(result.code == 0){
          this.projectStage = result.data.stageList;
          if(this.caseProject.type == '1'){
            this.getProjectNodeList()
          }
          console.info(this.projectStage)
        }else {
          Toast('获取工地验收进度信息失败');
        }
      },
      async getProjectNodeList(){
        for (let stage of this.projectStage){
          if(stage.status == '2' || stage.status == '3'){
            this.$set(this.stageMap, stage.id, false);
            let {code,data:nodeList} = await onestopProjectService.nodeList(this.caseProject.id,stage.stageId);
            this.$set(stage,'categoryList',nodeList.categoryList);
            for (let category of nodeList.categoryList) {
              console.info('category',category)
              let nodeImageArray = [];
              for(let node of category.onestopProjectNodeList){
                if(node.recordImages){
                  nodeImageArray = node.recordImages.split(',');
                }
                this.$set(node,'nodeImageArray',nodeImageArray);
              }
            }
          }else {
            this.$set(stage,'categoryList',[]);
          }
        }
      },
      async getEvaluateList(){
        var result = await EvaluateService.evaluateList('','',this.caseProject.id,this.caseProject.type);
        if(result.code == 0){
          this.customerEvaluateList = result.data;
          for (let evaluate of this.customerEvaluateList) {
            if(!evaluate.customerUser.nickname && !evaluate.customerName){
              evaluate.customerName = evaluate.onestopProject.customerName;
            }
          }
        }else {
          Toast('获取工长评价信息失败');
        }
      },
      async initWechatShare(){
        let title = this.projectName;// 分享标题
        let desc = "水木家居商城真实案例"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      async getProjectImageList(projectId){
        var result = await ProjectService.getProjectImageList(projectId);
        console.info('result.data',result.data)
        if(result.code == 0 && result.data){
          for (let projectImg of result.data){
            projectImg.attachmentList = projectImg.images.split(',');
            this.projectImageList.push(projectImg)
          }
        }else {
          Toast('获取工地实拍信息失败');
        }
      },
      previewImg(currentImage,imageList){
        let previewImageList = [];
        for (let image of imageList){
          let previewImage = this.imgUrl + image;
          previewImageList.push(previewImage);
        }
        wx.previewImage({
          current: currentImage,
          urls: previewImageList
        });
      },
      previewFullImg(currentImage,imageList){
        wx.previewImage({
          current: currentImage,
          urls: imageList
        });
      },
    }
  }
</script>

